import { VueConstructor } from 'vue'
import VueRouter from 'vue-router'
import store from './store/store'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

const ehAmbienteDeProducao = process.env.NODE_ENV === 'production'

export default class UsarSentry {
  static definirTaxaDeAmostragem (): number {
    const amostragemProducao = 0.0001 //  0.01%
    const amostragemDesenvolvimento = 0
    return ehAmbienteDeProducao ? amostragemProducao : amostragemDesenvolvimento
  }

  static definirTaxaDeAmostragemReplays (): number {
    const amostragemProducao = 0.0001 // 0.01%
    const amostragemDesenvolvimento = 0
    return ehAmbienteDeProducao ? amostragemProducao : amostragemDesenvolvimento
  }

  static inicializar (Vue: VueConstructor, router: VueRouter): void {
    Sentry.init({
      Vue,
      dsn: 'https://fdc7356eca9a42339224b4cd83d8c3b7@sentry.pontotel.com.br/21',
      environment: process.env.NODE_ENV,
      logErrors: !ehAmbienteDeProducao,
      maxBreadcrumbs: 50,
      /**
       * taxa de amostragem de erros que irão para o sentry
       */
      tracesSampleRate: UsarSentry.definirTaxaDeAmostragem(),
      /**
       * A taxa de amostragem para replays que começam a ser gravados
       * imediatamente e duram toda a sessão do usuário.
       */
      replaysSessionSampleRate: UsarSentry.definirTaxaDeAmostragemReplays(),
      /**
       * A taxa de amostragem para replays gravados quando ocorre um erro.
       * Este tipo de replay registrará até um minuto de eventos antes do
       * erro e continuará gravando até o término da sessão.
       */
      replaysOnErrorSampleRate: UsarSentry.definirTaxaDeAmostragem(),
      initialScope: (scope) => {
        scope.setTags({
          coletorId: store.state?.accessData?.coletor?.coletorId,
          clientId: store.state?.accessData?.coletor?.clientId
        })
        scope.setContext('coletor', {
          chaveColetor: store.state?.accessData?.coletor?.tokenColetor,
          coletorPendente: store.state?.accessData?.coletor?.coletorPendente,
          tipoColetor: store.state?.accessData?.coletor?.tipoColetor,
          regularChave: store.state?.accessData?.regularToken
        })
        return scope
      },
      integrations: [
        new Sentry.Replay(),
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: ['bateponto.pontotel.com.br', 'hml.pontotel.com.br', /^\//]
        })
      ]
    })
  }
}

/**
 * Função para remover dados sensíveis do objeto web do localstorage antes de enviar para o sentry
 * @param objeto web do localStorage
 * @returns objeto formatado sem dados sensíveis
 */
export const formatarObjetoWebParaSentry = (objeto: string):string => {
  if (!objeto) return JSON.parse('{}')

  const objetoFormatado = JSON.parse(objeto)

  objetoFormatado.formatadosParaSentry = {
    chaveAcesso: objetoFormatado?.accessData?.cognitoInfo?.accessToken,
    chaveColetor: objetoFormatado?.accessData?.coletor?.tokenColetor,
    chaveRegular: objetoFormatado.accessData?.regularToken
  }

  delete objetoFormatado?.accessData?.cognitoInfo?.accessToken
  delete objetoFormatado?.accessData?.coletor?.tokenColetor
  delete objetoFormatado.accessData?.regularToken

  return JSON.stringify(objetoFormatado)
}
